import type { SeasonalThemeDefinition } from '../../SeasonalTheme';
import { AutumnHeaderPumpkin } from './AutumnHeaderPumpkin';
import { AutumnLoader } from './AutumnLoader';

/**
 * Autumn: a pumpkin in the header (click it three times quickly for the easter egg) and a pumpkin loader with
 * falling leaves. The app bar itself keeps its regular colours.
 */
export const autumnTheme: SeasonalThemeDefinition = {
  name: 'autumn',
  label: 'Høst 🎃',
  HeaderDecoration: AutumnHeaderPumpkin,
  Loader: AutumnLoader,
};

export default autumnTheme;
